"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialPaymentsSchema = void 0;
exports.partialPaymentsSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        comment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 40,
            errorMessage: 'should be a string with maximum length of 40 characters',
        },
        indexNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 100,
            errorMessage: 'Should be an integer between 0 and 100',
        },
        previouslyApprovedAmount: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with maximum length of 100 characters or null',
        },
        previouslyApprovedDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with maximum length of 100 characters or null',
        },
        receivedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        receivedDate: {
            type: 'string',
            format: 'date',
            strictlyPastDate: true,
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
    },
};
